import React, { FunctionComponent } from 'react'
import Svg, { Path } from 'react-native-svg'

import { useTheme } from 'styled-components/native'

import { AuroraThemeType } from '../../utils/themes/ThemeProvider'

type Props = {
  size?: number | string
}

export const AuroraGuidedSelfCareSecondaryRecIllustration: FunctionComponent<Props> = ({ size = 64 }) => {
  const { colors } = useTheme() as AuroraThemeType
  const { spotIllustration } = colors.icons

  return (
    <Svg width={size} height={size} viewBox='0 0 64 64' fill='none'>
      <Path d='M23.6257 14.8713L23.6241 14.876L23.6226 14.8713H23.6257Z' fill='#3BA5B5' />
      <Path d='M23.6271 14.8682L23.6302 14.8713H23.6255L23.6271 14.8682Z' fill='#3BA5B5' />
      <Path
        d='M54.9523 44.4655C54.9445 45.1203 54.5143 45.6993 53.8761 45.9129C51.6377 46.6622 46.3584 48.4548 42.8499 49.8388C38.7015 51.4751 34.561 52.6532 33.8603 52.8482C33.7867 52.8684 33.7132 52.8838 33.6366 52.8947C33.2189 52.9504 31.7736 53.1099 30.3345 52.8776C30.3345 52.8776 30.322 52.873 30.2969 52.8653C29.4507 52.5835 14.2449 47.509 9.96982 45.7334C9.38167 45.4888 9 44.9284 9 44.3076V13.8744C9 12.7846 10.1247 12.0369 11.1727 12.427C16.4395 14.3946 29.5117 19.8159 30.2954 20.1425C30.3188 20.1518 30.3329 20.1564 30.3329 20.1564H33.4661C33.6585 20.1564 33.8493 20.1224 34.0276 20.0574L52.7592 13.2212C53.8088 12.8388 54.9272 13.5942 54.9194 14.6825C54.8866 19.2028 54.8287 29.1475 54.9366 31.6554C55.0508 34.2855 54.982 41.6666 54.9507 44.4655H54.9523Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M52.2981 12.7397V43.4345L32.2135 50.6608C32.1149 50.6948 32.0101 50.7041 31.9084 50.6825C31.8865 50.6778 31.8646 50.6716 31.8427 50.6639L11.5156 43.662V12.3604C11.5156 11.9068 11.8332 11.5074 12.2805 11.4114C24.2907 8.81226 31.9084 19.3777 31.9084 19.3777C34.9821 13.1638 47.2629 11.8975 51.1281 11.6498C51.7632 11.6096 52.2981 12.1096 52.2981 12.7381V12.7397Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M52.2979 12.7396V43.4344L32.2132 50.6607C32.1147 50.6948 32.0099 50.7041 31.9082 50.6824V19.3792C32.9046 17.3636 34.8693 15.8682 37.2015 14.7614C39.16 13.8294 41.3749 13.1715 43.4944 12.7086C46.637 12.0167 49.5668 11.7519 51.1279 11.6513C51.7629 11.6111 52.2979 12.1111 52.2979 12.7396Z'
        fill={spotIllustration.primary.fill}
      />
      <Path
        d='M43.4945 12.707L43.1958 23.6765L40.3849 21.5944L37.2017 25.1859V14.7598C39.1601 13.8278 41.375 13.1699 43.4945 12.707Z'
        fill={spotIllustration.secondary.fill}
      />
      <Path
        d='M32.4321 49.7622L32.4321 20.7127C32.4321 20.4224 32.1968 20.187 31.9065 20.187C31.6162 20.187 31.3808 20.4224 31.3808 20.7127L31.3808 49.7622C31.3808 50.0525 31.6162 50.2878 31.9065 50.2878C32.1968 50.2878 32.4321 50.0525 32.4321 49.7622Z'
        fill={spotIllustration.secondary.fill}
      />
    </Svg>
  )
}
